<template>
    <div class="icon-renderer">
        <icon v-if="params.value" :icon-name="params.value.icon" :color="params.value.color" />
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped></style>
